export default "__VITE_ASSET__MdrDh_sW__"